import { Resume } from '@/api/types';
import { getLocalItem, setLocalItem, getResumesKey } from './storage';
import { APP_ERRORS } from '@/constants/errors';

export const getResumes = async (workspaceId: string): Promise<{ items: Resume[]; selectedResumeId: string | null }> => {
  const resumes = await getLocalItem<Resume[]>(getResumesKey(workspaceId), []);
  return { items: resumes, selectedResumeId: null };
};

export const uploadResume = async (workspaceId: string, fileContentBase64: string, name: string, label: string): Promise<Resume> => {
  let resumes = await getLocalItem<Resume[]>(getResumesKey(workspaceId), []);
  if (resumes.length >= 10) {
    throw new Error(APP_ERRORS.RESUME_STORE_FULL.message);
  }
  const newResume: Resume = {
    id: Math.random().toString(36).substring(7),
    label: label || name,
    name,
    path: `local-file://${name}`,
    addedAt: new Date().toISOString(),
    contentBase64: fileContentBase64,
  };
  resumes.push(newResume);
  await setLocalItem(getResumesKey(workspaceId), resumes);
  return newResume;
};

export const deleteResume = async (workspaceId: string, id: string): Promise<void> => {
  let resumes = await getLocalItem<Resume[]>(getResumesKey(workspaceId), []);
  resumes = resumes.filter(r => r.id !== id);
  await setLocalItem(getResumesKey(workspaceId), resumes);
};
